import React, { FC } from "react";
import { DPPageWrapper } from "Components/DP";
type Props = {
  text?: string;
};
const NotFound: FC<Props> = ({ text = "404" }) => {
  return (
    <DPPageWrapper title={text}>
      {
        <h1>
          We're sorry - we can't find the page you're looking for. ({text})
        </h1>
      }
    </DPPageWrapper>
  );
};

export default NotFound;
